<script setup>
import moment from "moment";
import listStatus from "@/data/statusIMKP.json";
import { levelEnum, statusIMKPEnum } from "@/utilities/enum";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div class="flex justify-between items-end">
          <div>
            <h2 class="text-red-600 text-3xl font-inter font-bold">
              {{
                role === levelEnum.ISAFE || role === levelEnum.REPORTER
                  ? "Report IMKP (Izin Melaksanakan Kegiatan Proyek)"
                  : "Approval IMKP (Izin Melaksanakan Kegiatan Proyek)"
              }}
            </h2>
            <p class="text-gray-500">
              Sini-Saja membantu mengelola & memantau perkembangan kegiatan
              kontraktor
            </p>
          </div>
          <div
            class="flex justify-end flex-wrap gap-2"
            v-if="role === levelEnum.ADMIN || role === levelEnum.OHS"
          >
            <v-btn
              class="bg-blue-600 text-white capitalize position-relative"
              @click="clickRequestPengajuanIMKP"
            >
              <span
                class="absolute -top-2 -left-4 bg-red-600 rounded-full px-1 py-0.5 text-xs"
                v-if="requestCount >= 1"
              >
                {{ requestCount }}
              </span>
              <font-awesome-icon
                icon="fa-solid fa-file-circle-question"
                style="color: #eeecec"
                class="mr-2"
              />
              Request Pengajuan IMKP
            </v-btn>
            <v-btn
              class="bg-red-600 text-white capitalize"
              @click="clickPengajuanIMKP"
            >
              <font-awesome-icon
                icon="fa-solid fa-file-circle-plus"
                style="color: #eeecec"
                class="mr-2"
              />
              Pengajuan IMKP
            </v-btn>
          </div>
        </div>
        <v-row class="mt-5">
          <v-col cols="6">
            <table
              class="table w-100 rounded table-borderless"
              style="overflow: hidden; font-family: 'Inter-Regular', serif"
            >
              <thead class="font-inter text-[#28293d] font-normal">
                <tr class="table-danger" style="max-height: 5vh">
                  <th class="p-2 text-nowrap text-sm" style="width: 30%">
                    Status
                  </th>
                  <th class="p-2 text-nowrap text-sm" style="width: 70%">
                    Keterangan
                  </th>
                </tr>
              </thead>
              <tbody class="text-xs">
                <tr
                  v-for="(data, index) in listStatus.filter((status) =>
                    status.role.some((level) => level === role),
                  )"
                  :key="index"
                >
                  <td
                    class="align-items-center"
                    :class="{ 'table-secondary': index % 2 == 1 }"
                  >
                    <span
                      class="p-1 rounded-md text-white mx-auto"
                      :style="`background-color: ${data.color};`"
                    >
                      {{ data.name }}
                    </span>
                  </td>
                  <td :class="{ 'table-secondary': index % 2 == 1 }">
                    {{ data.description }}
                  </td>
                </tr>
              </tbody>
            </table>
          </v-col>
          <v-col cols="12">
            <v-row class="bg-white rounded-lg p-3 shadow-md mt-5">
              <v-col cols="4">
                <v-text-field
                  variant="outlined"
                  density="compact"
                  color="red"
                  hide-details
                  clearable
                  v-model="paramsImkp.keyword"
                  @keyup.enter="fetchData"
                  prepend-inner-icon="mdi-magnify"
                  placeholder="Masukkan Nama Kontraktor"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-btn
                  class="w-full bg-slate-50 text-slate-600 capitalize"
                  @click="dialogFilterImkp = true"
                >
                  Cari Berdasarkan
                </v-btn>
              </v-col>
              <v-col cols="4">
                <v-btn
                  class="bg-red-600 w-full text-white capitalize"
                  @click="fetchData"
                >
                  Cari Kontraktor
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <div class="my-8 rounded-lg shadow-md overflow-x-auto w-full">
            <v-data-table-server
              border="0"
              v-model:items-per-page="dataTable.pagination.itemsPerPage"
              :items-per-page-options="[5, 10, 25, 50, 100]"
              :headers="dataTable.headers"
              :items="formattedItems"
              :items-length="dataTable.pagination.totalItems"
              @update:options="fetchData"
            >
              <template v-slot:item="{ item, index }">
                <tr
                  v-for="(dataImkp, dataKey) in item.imkps"
                  :key="dataKey"
                  class="border-gray-950 h-16"
                  :class="{
                    'bg-gray-50': index % 2 !== 0,
                    'border-t': dataKey === 0,
                  }"
                >
                  <td>
                    {{ dataKey === 0 ? dataImkp.namaKontraktor : "" }}
                  </td>
                  <td class="text-wrap">
                    {{ dataImkp.judulProyek }}
                    <span
                      class="py-1 px-2 me-3 badge rounded text-sm-center text-black mx-auto bg-info-subtle"
                      v-if="dataImkp.status !== statusIMKPEnum.DRAFT"
                    >
                      Revisi ke- {{ dataImkp.revisi }}
                    </span>
                    <span
                      class="py-1 px-2 me-3 badge rounded text-sm-center text-black bg-primary-subtle"
                      v-if="
                        dataImkp.status !== statusIMKPEnum.DRAFT &&
                        dataImkp.amandemen !== 0
                      "
                    >
                      Amandemen ke- {{ dataImkp.amandemen }}
                    </span>
                    <span
                      class="py-1 px-2 badge rounded text-sm-center text-black bg-warning cursor-pointer"
                      v-if="
                        dataImkp.status !== statusIMKPEnum.DRAFT &&
                        dataImkp.amandemen !== 0
                      "
                      @click="openHistory(dataImkp.id)"
                    >
                      Lihat history
                    </span>
                    <div
                      v-if="
                        dataImkp.isFinished &&
                        !dataImkp.isObsolete &&
                        dataImkp.status !== 8
                      "
                    >
                      <p class="fs-8 m-0 text-danger fw-semibold fst-italic">
                        <span class="fs-7">*</span>
                        IMKP pada proyek ini belum melakukan BAST
                      </p>
                    </div>
                    <div
                      v-if="dataImkp.isObsolete"
                      class="d-flex align-items-center gap-2"
                    >
                      <ul class="fs-8 m-0 text-danger fw-semibold opacity-100">
                        <li
                          v-for="(item, i) in normalizeList(
                            dataImkp.alasanTolak,
                          )"
                          :key="i"
                        >
                          {{ item }}
                        </li>
                      </ul>
                      <a
                        class="text-danger fw-bolder cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        :title="'Lihat Detail'"
                        style="text-decoration: none"
                        @click="
                          redirectToLink('/verifikasi-data-imkp/', dataImkp.id)
                        "
                      >
                        <img
                          :src="require('@/assets/icons/lihat_dokumen_sio.png')"
                          alt=""
                          class="h-auto"
                          :style="'width: 1.5rem;'"
                        />
                      </a>
                    </div>
                    <div
                      v-if="
                        dataImkp.alasanTolak &&
                        (dataImkp.status === statusIMKPEnum.NEED_REVISION ||
                          dataImkp.status === statusIMKPEnum.UNDER_REVIEW)
                      "
                    >
                      <p
                        class="italic text-red-600 font-semibold m-0 text-sm"
                        style="white-space: pre-line"
                      >
                        Catatan: {{ dataImkp.alasanTolak }}
                      </p>
                    </div>
                  </td>
                  <td
                    class="text-center"
                    :class="{ 'opacity-50': dataImkp.isObsolete }"
                  >
                    {{
                      dataImkp.tanggalMulaiPekerjaan
                        ? moment(
                            new Date(dataImkp.tanggalMulaiPekerjaan),
                          ).format("DD MMM YYYY")
                        : null
                    }}
                  </td>
                  <td
                    class="text-center"
                    :class="{ 'opacity-50': dataImkp.isObsolete }"
                  >
                    {{
                      dataImkp.tanggalSelesaiPekerjaan
                        ? moment(
                            new Date(dataImkp.tanggalSelesaiPekerjaan),
                          ).format("DD MMM YYYY")
                        : null
                    }}
                  </td>
                  <td
                    class="text-center"
                    :class="{ 'opacity-50': dataImkp.isObsolete }"
                  >
                    <div
                      v-if="
                        listStatus.some(
                          (data) => data.status === dataImkp.status,
                        )
                      "
                    >
                      <span
                        v-for="data in listStatus.filter(
                          (data) => data.status === dataImkp.status,
                        )"
                        :key="data.id"
                        class="badge"
                        style="color: #f2f0f0"
                        :style="{ 'background-color': data.color }"
                      >
                        {{ data.name }}
                      </span>
                    </div>
                  </td>
                  <td
                    class="text-center flex justify-between items-center border-b-0 w-full"
                  >
                    <a
                      :class="{
                        'opacity-50':
                          dataImkp.isObsolete || dataImkp.isAnyFinished,
                      }"
                      class="text-danger fw-bolder cursor-pointer"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      :title="
                        !dataImkp.isObsolete && !dataImkp.isAnyFinished
                          ? 'Verifikasi Dokumen '
                          : 'Verifikasi Dokumen '
                      "
                      style="text-decoration: none"
                      @click="
                        !dataImkp.isObsolete && !dataImkp.isAnyFinished
                          ? role === levelEnum.ADMIN || role === levelEnum.OHS
                            ? redirectToLink(
                                '/verifikasi-data-imkp/',
                                dataImkp.id,
                              )
                            : redirectToLink('/imkp/', dataImkp.id)
                          : ''
                      "
                    >
                      <img
                        :src="
                          !dataImkp.isObsolete
                            ? require('@/assets/icons/lihat_dokumen_sio.png')
                            : require('@/assets/icons/close-64.png')
                        "
                        alt=""
                        class="h-auto"
                        :style="
                          !dataImkp.isObsolete ? 'width: 2rem;' : 'width: 4rem'
                        "
                      />
                    </a>
                    <a
                      v-if="role === levelEnum.ADMIN || role === levelEnum.OHS"
                      @click="
                        dataImkp.status !== statusIMKPEnum.DRAFT &&
                        dataImkp.status !== statusIMKPEnum.NEED_REVISION &&
                        dataImkp.status !== statusIMKPEnum.UNDER_REVIEW &&
                        !dataImkp.isAnyFinished
                          ? redirectToLink('/preview-imkp/', dataImkp.id)
                          : ''
                      "
                      class="text-danger fw-bolder cursor-pointer"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      :title="
                        !dataImkp.isObsolete &&
                        !dataImkp.isAnyFinished &&
                        dataImkp.status !== statusIMKPEnum.DRAFT &&
                        dataImkp.status !== statusIMKPEnum.NEED_REVISION &&
                        dataImkp.status !== statusIMKPEnum.UNDER_REVIEW
                          ? 'Preview IMKP '
                          : 'Preview IMKP '
                      "
                      style="text-decoration: none"
                      :class="{
                        'opacity-50':
                          dataImkp.status === statusIMKPEnum.DRAFT ||
                          dataImkp.status === statusIMKPEnum.NEED_REVISION ||
                          dataImkp.status === statusIMKPEnum.UNDER_REVIEW ||
                          dataImkp.isObsolete ||
                          dataImkp.isAnyFinished,
                      }"
                    >
                      <img
                        src="../../assets/icons/penerbitan_sio.png"
                        alt=""
                        style="width: 1.5rem; height: auto"
                      />
                    </a>
                    <a
                      v-if="role === levelEnum.ADMIN || role === levelEnum.OHS"
                      class="text-danger fw-bolder cursor-pointer"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Process BAST"
                      style="text-decoration: none"
                      :class="{
                        'opacity-50':
                          (dataImkp.status !== statusIMKPEnum.BAST_PROCESS &&
                            dataImkp.status !== statusIMKPEnum.BAST_WARRANTY &&
                            dataImkp.status !==
                              statusIMKPEnum.BAST_WARRANTY_REVISION &&
                            dataImkp.status !== statusIMKPEnum.IMKP_DONE) ||
                          dataImkp.isObsolete,
                      }"
                      @click="
                        dataImkp.status === statusIMKPEnum.BAST_PROCESS ||
                        dataImkp.status === statusIMKPEnum.BAST_WARRANTY ||
                        dataImkp.status ===
                          statusIMKPEnum.BAST_WARRANTY_REVISION ||
                        dataImkp.status === statusIMKPEnum.IMKP_DONE
                          ? clickBast(
                              dataImkp.id,
                              dataImkp.idSio,
                              dataImkp.idKontraktor,
                              dataImkp.status,
                              dataImkp.judulProyek,
                              dataImkp.namaKontraktor,
                              'BAST',
                            )
                          : ''
                      "
                    >
                      <img
                        src="../../assets/icons/file-contract.png"
                        alt=""
                        style="height: auto; width: 1.4rem"
                      />
                    </a>
                    <a
                      v-if="role === levelEnum.ADMIN || role === levelEnum.OHS"
                      class="text-danger fw-bolder cursor-pointer"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="BAST Garansi"
                      style="text-decoration: none"
                      :class="{
                        'opacity-50':
                          (dataImkp.status !== statusIMKPEnum.BAST_WARRANTY &&
                            dataImkp.status !==
                              statusIMKPEnum.BAST_WARRANTY_REVISION &&
                            dataImkp.status !== statusIMKPEnum.IMKP_DONE) ||
                          dataImkp.isObsolete ||
                          !dataImkp.isNeedBastWarranty,
                      }"
                      @click="
                        (dataImkp.status === statusIMKPEnum.BAST_WARRANTY ||
                          dataImkp.status ===
                            statusIMKPEnum.BAST_WARRANTY_REVISION ||
                          dataImkp.status === statusIMKPEnum.IMKP_DONE) &&
                        dataImkp.isNeedBastWarranty
                          ? clickBast(
                              dataImkp.id,
                              dataImkp.idSio,
                              dataImkp.idKontraktor,
                              dataImkp.status,
                              dataImkp.judulProyek,
                              dataImkp.namaKontraktor,
                              'BAST Garansi',
                            )
                          : ''
                      "
                    >
                      <img
                        src="../../assets/icons/file-contract-warranty.png"
                        alt=""
                        style="height: auto; width: 3.4rem"
                      />
                    </a>

                    <a
                      v-if="role === levelEnum.ADMIN || role === levelEnum.OHS"
                      class="text-danger fw-bolder cursor-pointer"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      :title="
                        dataImkp.status === statusIMKPEnum.IMKP_PUBLISHED
                          ? 'Amandemen '
                          : 'Amandemen '
                      "
                      style="text-decoration: none"
                      :class="{
                        'opacity-50':
                          dataImkp.status !== statusIMKPEnum.IMKP_PUBLISHED ||
                          dataImkp.tempAmandemenList.length === 0 ||
                          dataImkp.isObsolete,
                      }"
                      @click="
                        dataImkp.status === statusIMKPEnum.IMKP_PUBLISHED &&
                        dataImkp.tempAmandemenList.length !== 0
                          ? redirectToLink('/amandemen-data-imkp/', dataImkp.id)
                          : ''
                      "
                    >
                      <img
                        src="../../assets/icons/file-amandemen.png"
                        alt=""
                        style="width: 1.4rem; height: auto"
                      />
                    </a>
                    <a>
                      <div class="flex gap-2 items-center">
                        <i
                          :hidden="dataImkp.isObsolete"
                          class="mdi mdi-delete text-red-600 text-2xl cursor-pointer"
                          @click="hapusImkp(dataImkp.id)"
                        ></i>
                      </div>
                    </a>
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </DefaultLayout>

  <ApprovalBastImkpModal
    v-model="dialogApproveBast"
    :imkp-id="bastContext.id"
    :sio-id="bastContext.sioID"
    :kontraktor-id="bastContext.kontraktorID"
    :status="bastContext.status"
    :judul-proyek="bastContext.judulProyek"
    :nama-kontraktor="bastContext.namaKontraktor"
    :usecase="role"
    @submitted="fetchData"
  />

  <ApprovalBastWarrantyImkpModal
    v-model="dialogApproveBastGaransi"
    :imkp-id="bastContext.id"
    :kontraktor-id="bastContext.kontraktorID"
    :status="bastContext.status"
    :judul-proyek="bastContext.judulProyek"
    :nama-kontraktor="bastContext.namaKontraktor"
    :usecase="role"
    @submitted="fetchData"
  />

  <HistoryAmandemenImkpModal
    v-model="dialogHistoryAmandemen"
    :imkp-id="imkpId"
    :usecase="role"
  />

  <div v-if="isLoading" class="loading-overlay" style="z-index: 3070">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>

  <CreateImkpModal
    v-model="dialogCreateImkp"
    title="Pengajuan IMKP"
    @submit="submitKirimPengajuan"
  />

  <FilterImkpModal
    v-model="dialogFilterImkp"
    :filter="paramsImkp"
    :list-status="listStatus"
    :role="role"
    @update:filter="onFilterUpdate"
    @apply="terapkan"
    @refresh="resetFilterImkp"
  />

  <RequestImkpModal
    v-model="dialogRequestImkp"
    v-model:request-count="requestCount"
    v-model:loading="isLoading"
    @action-complete="onRequestActionComplete"
  />
</template>

<script>
import GlobalDataMixin from "@/GlobalDataMixin";
// import SidebarComponent from "@/components/SideBar.vue";
import {
  API_BASE_URL,
  CMS_GET_IMKP_REQUEST,
  CMS_LIST_IMKP,
  CMS_SET_IMKP_OHS,
  CMS_DELETE_IMKP,
} from "@/constants";
import router from "@/router";
import axios from "axios";
import Swal from "sweetalert2";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";
import CreateImkpModal from "./components/CreateImkpModal.vue";
import { serializeSubLokasiForApi } from "./core/subLokasiHelpers";
import FilterImkpModal from "./components/FilterImkpModal.vue";
import RequestImkpModal from "./components/RequestImkpModal.vue";
import ApprovalBastImkpModal from "./components/ApprovalBastImkpModal.vue";
import ApprovalBastWarrantyImkpModal from "./components/ApprovalBastWarrantyImkpModal.vue";
import HistoryAmandemenImkpModal from "./components/HistoryAmandemenImkpModal.vue";
import util from "@/assets/js/util";

const url_list = API_BASE_URL + CMS_LIST_IMKP;
const url_pengajuan_imkp = API_BASE_URL + CMS_SET_IMKP_OHS;
const url_list_request_imkp = API_BASE_URL + CMS_GET_IMKP_REQUEST;
const url_delete_imkp = API_BASE_URL + CMS_DELETE_IMKP;

export default {
  mixins: [GlobalDataMixin],
  name: "ApprovalImkpPage",
  components: {
    DefaultLayout,
    CreateImkpModal,
    FilterImkpModal,
    RequestImkpModal,
    ApprovalBastImkpModal,
    ApprovalBastWarrantyImkpModal,
    HistoryAmandemenImkpModal,
  },
  data() {
    return {
      dataTable: CreateDataTableObject([
        {
          title: "Nama Kontraktor",
          key: "namaKontraktor",
          align: "start",
          sortable: true,
          width: "19%",
        },
        {
          title: "Judul Proyek",
          key: "judulProyek",
          align: "start",
          sortable: true,
          width: "28%",
        },
        {
          title: "Tanggal Mulai",
          key: "tanggalDari",
          align: "start",
          sortable: true,
          width: "10%",
        },
        {
          title: "Tanggal Selesai",
          key: "tanggalSampai",
          align: "start",
          sortable: true,
          width: "10%",
        },
        {
          title: "Status",
          key: "status",
          align: "center",
          sortable: true,
          width: "13%",
        },
        { title: "Aksi", align: "center", sortable: false, width: "20%" },
      ]),
      isLoading: false,
      imkps: [],
      paramsImkp: {
        page: 0,
        perPage: 5,
        totalRecord: 0,
        total: 0,
        keyword: null,
        sortBy: "",
        sortDirection: "",
        namaKontraktor: null,
        judulProyek: null,
        status: null,
        tanggalDari: null,
        tanggalSampai: null,
      },
      filtersInitialized: false,
      role: null,
      requestCount: 0,
      imkpId: null,
      bastContext: {
        id: null,
        sioID: null,
        kontraktorID: null,
        status: null,
        judulProyek: "",
        namaKontraktor: "",
      },
      dialogCreateImkp: false,
      dialogFilterImkp: false,
      dialogRequestImkp: false,
      dialogApproveBast: false,
      dialogApproveBastGaransi: false,
      dialogHistoryAmandemen: false,
    };
  },
  created() {
    this.role = this.resolveUserRole(this.userData.role);
    this.initFiltersFromQuery();
    this.getCountRequest();
    setInterval(this.getCountRequest, 5000);
  },
  mounted() {
    this.filtersInitialized = true;
  },
  activated() {
    if (this.filtersInitialized) {
      this.initFiltersFromQuery();
      this.fetchData();
    }
  },
  computed: {
    formattedItems() {
      const items = this.dataTable.items || {};

      return Object.entries(items)
        .reverse() // Membalik urutan key-value
        .map(([key, value]) => ({
          id: key,
          imkps: value,
        }));
    },
  },
  methods: {
    initFiltersFromQuery() {
      const q = this.$route.query;
      this.paramsImkp.keyword = q.keyword ?? null;
      this.paramsImkp.namaKontraktor = q.namaKontraktor ?? null;
      this.paramsImkp.judulProyek = q.judulProyek ?? null;
      this.paramsImkp.status =
        q.status !== undefined && q.status !== "" ? Number(q.status) : null;
      this.paramsImkp.tanggalDari = q.tanggalDari ?? null;
      this.paramsImkp.tanggalSampai = q.tanggalSampai ?? null;
      if (q.page !== undefined && q.page !== "") {
        this.paramsImkp.page = Number(q.page);
        this.dataTable.pagination.page = Number(q.page);
      }
      if (q.perPage !== undefined && q.perPage !== "") {
        this.paramsImkp.perPage = Number(q.perPage);
        this.dataTable.pagination.itemsPerPage = Number(q.perPage);
      }
    },
    syncFiltersToUrl() {
      const query = {
        keyword: this.paramsImkp.keyword || undefined,
        namaKontraktor: this.paramsImkp.namaKontraktor || undefined,
        judulProyek: this.paramsImkp.judulProyek || undefined,
        status:
          this.paramsImkp.status !== null &&
          this.paramsImkp.status !== undefined
            ? this.paramsImkp.status
            : undefined,
        tanggalDari: this.paramsImkp.tanggalDari || undefined,
        tanggalSampai: this.paramsImkp.tanggalSampai || undefined,
        page:
          this.paramsImkp.page !== undefined && this.paramsImkp.page > 1
            ? this.paramsImkp.page
            : undefined,
        perPage:
          this.paramsImkp.perPage !== 5 ? this.paramsImkp.perPage : undefined,
      };
      this.$router.replace({ query }).catch(() => {});
    },
    buildApprovalImkpQuery() {
      const q = {};
      if (this.paramsImkp.keyword) q.keyword = this.paramsImkp.keyword;
      if (this.paramsImkp.namaKontraktor)
        q.namaKontraktor = this.paramsImkp.namaKontraktor;
      if (this.paramsImkp.judulProyek)
        q.judulProyek = this.paramsImkp.judulProyek;
      if (
        this.paramsImkp.status !== null &&
        this.paramsImkp.status !== undefined
      )
        q.status = this.paramsImkp.status;
      if (this.paramsImkp.tanggalDari)
        q.tanggalDari = this.paramsImkp.tanggalDari;
      if (this.paramsImkp.tanggalSampai)
        q.tanggalSampai = this.paramsImkp.tanggalSampai;
      if (this.paramsImkp.page !== undefined && this.paramsImkp.page > 1)
        q.page = this.paramsImkp.page;
      if (this.paramsImkp.perPage !== 5) q.perPage = this.paramsImkp.perPage;
      return q;
    },
    onRequestActionComplete() {
      this.fetchData();
      this.getCountRequest();
    },
    beautifyMessage(message) {
      if (typeof message !== "string") return message;
      return message.replace(/\[[^\][]*]/g, (match) => {
        try {
          const parsed = JSON.parse(match);
          if (Array.isArray(parsed)) {
            return parsed.map((item) => String(item).trim()).join(", ");
          }
        } catch {
          // bukan JSON array valid → biarkan apa adanya
        }
        return match;
      });
    },
    openHistory(id) {
      this.imkpId = id;
      this.dialogHistoryAmandemen = true;
    },
    onFilterUpdate(filter) {
      Object.assign(this.paramsImkp, filter);
    },
    resetFilterImkp() {
      this.paramsImkp.judulProyek = null;
      this.paramsImkp.namaKontraktor = null;
      this.paramsImkp.status = null;
      this.paramsImkp.tanggalDari = null;
      this.paramsImkp.tanggalSampai = null;
      this.paramsImkp.page = 1;
      this.dataTable.pagination.page = 1;
      this.syncFiltersToUrl();
      this.fetchData();
    },
    terapkan() {
      this.paramsImkp.page = 1;
      this.dataTable.pagination.page = 1;
      this.syncFiltersToUrl();
      this.fetchData();
    },
    refresh() {
      this.paramsImkp.keyword = null;
      this.paramsImkp.judulProyek = null;
      this.paramsImkp.namaKontraktor = null;
      this.paramsImkp.status = null;
      this.paramsImkp.tanggalDari = null;
      this.paramsImkp.tanggalSampai = null;
      this.paramsImkp.page = 1;
      this.dataTable.pagination.page = 1;
      this.syncFiltersToUrl();
      this.fetchData();
    },
    clickPengajuanIMKP() {
      this.dialogCreateImkp = true;
    },
    clickRequestPengajuanIMKP() {
      this.dialogRequestImkp = true;
    },
    getCountRequest() {
      if (this.$route.path !== "/approval-imkp") return;

      axios
        .get(url_list_request_imkp, {
          params: { page: 0, perPage: 1 },
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((res) => {
          this.requestCount = res.data?.header?.totalRows ?? 0;
        })
        .catch(() => {});
    },
    async submitKirimPengajuan(formData) {
      this.isLoading = true;
      let bodyJson = {
        sioId: formData.kontraktor.idSio,
        kontraktorId: formData.kontraktor.id,
        judulProyek: formData.judulProyek,
        lokasiKerja: formData.lokasiKerja.location_name,
        subLokasi: serializeSubLokasiForApi(formData.subLokasi),
        keteranganLokasiKerja: formData.keteranganLokasiKerja,
        usecase: this.role,
      };

      try {
        const result = await axios.post(url_pengajuan_imkp, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        });

        if (result.data.status.StatusCode === 400) {
          util.showError(
            this.beautifyMessage(result.data.status.message),
            5000,
          );
        } else {
          util.showInfo("Kirim Pengajuan IMKP berhasil dibuat!", 2000);
          this.fetchData();
          this.dialogCreateImkp = false;
        }
      } catch (error) {
        console.log("ERR submitKirimPengajuan : ", error);
        util.showError("Terjadi kesalahan saat mengirim pengajuan IMKP.", 5000);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData({ page, itemsPerPage, sortBy } = {}) {
      try {
        if (page) {
          this.paramsImkp.page = page;
        }
        if (itemsPerPage) {
          this.paramsImkp.perPage = itemsPerPage;
        }
        this.syncFiltersToUrl();

        this.isLoading = true;
        let params = {
          page: this.paramsImkp.page,
          perPage: this.paramsImkp.perPage,
          sortBy: sortBy ? sortBy[0]?.order : null,
          sortDirection: sortBy ? sortBy[0]?.key : null,
          search: this.paramsImkp.keyword?.trim(),
          namaKontraktor: this.paramsImkp.namaKontraktor?.trim(),
          judulProyek: this.paramsImkp.judulProyek?.trim(),
          status: this.paramsImkp.status,
          tanggalDari: this.paramsImkp.tanggalDari
            ? moment(new Date(this.paramsImkp.tanggalDari)).format("YYYY-MM-DD")
            : null,
          tanggalSampai: this.paramsImkp.tanggalSampai
            ? moment(new Date(this.paramsImkp.tanggalSampai)).format(
                "YYYY-MM-DD",
              )
            : null,
        };

        const res = await axios.get(url_list, {
          params: params,
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        });

        if (res.data.data) {
          this.imkps = await this.groupDataByNamaKontraktor(res.data.data);
          this.paramsImkp.page = res.data.page;
          this.paramsImkp.perPage = res.data.perPage;
          this.paramsImkp.totalRecord = res.data.totalRecord;
          this.paramsImkp.total = res.data.total;

          let result = {};
          result.data = await this.groupDataByNamaKontraktor(res.data.data);
          result.total_data = res.data.total;
          result.total_per_page = this.paramsImkp.perPage;
          result.current_page = this.paramsImkp.page;
          this.dataTable = SetDataTableResponse(this.dataTable, result);
          // console.log({ data });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan!",
        });
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    redirectToLink(link, id) {
      router.push({
        path: link + id,
        query: this.buildApprovalImkpQuery(),
      });
    },
    groupDataByNamaKontraktor(data) {
      return data.reduce((groups, item) => {
        const key = item.idKontraktor;
        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(item);
        return groups;
      }, {});
    },
    clickBast(
      id,
      sioID,
      kontraktorID,
      status,
      judulProyek,
      namaKontraktor,
      type,
    ) {
      this.bastContext = {
        id,
        sioID,
        kontraktorID,
        status,
        judulProyek,
        namaKontraktor,
      };

      if (type === "BAST") {
        this.dialogApproveBast = true;
      } else if (type === "BAST Garansi") {
        this.dialogApproveBastGaransi = true;
      }
    },
    normalizeList(text) {
      if (!text) return [];
      return text
        .split(/\r?\n/) // split by line break
        .filter(Boolean); // remove empty lines
    },
    hapusImkp(id) {
      Swal.fire({
        title: "Apakah Anda yakin akan menghapus IMKP ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteImkp(id);
        }
      });
    },
    deleteImkp(id) {
      axios
        .get(url_delete_imkp, {
          params: {
            id: id,
          },
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
          },
        })
        .then(() => {
          Swal.fire({
            title: "Hapus IMKP",
            text: "Data IMKP telah dihapus !",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then(() => {
            window.location.reload();
          });
        })
        .catch((error) => {
          console.log(error);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan (" + error.response.data.message + ")",
          });
        });
    },
  },
};
</script>

<style scoped>
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

.is-invalid-v-select {
  border: 1.4px solid #dc3545;
  border-radius: 5px;
}
.bg_thead_body {
  background-color: #f8d7da;
}

.masked > img {
  opacity: 0;
  width: auto;
  display: block;
}
:deep(thead) {
  background-color: #fecaca;
}
/* :deep(.v-data-table tbody tr), */
:deep(.v-data-table tbody tr td) {
  border-bottom: none !important;
}
</style>
